export const businessTypes = [
  'Apparel & Footwear',
  'Electronics',
  'Books, Toys & Hobby',
  'Food & Beverage',
  'Gift Shop',
  'Health & Beauty Supplies',
  'Jewelry & Accessories',
  'Motorized Vehicles',
  'Wine & Liquor',
  'Sporting & Outdoor Goods',
  'Other',
];

export const industries = [
  'Retail',
  'Wholesale or distribution',
  'Ecommerce',
  'Services',
  'Health',
  'Fashion',
  'Beauty',
  'Other',
];
